"use client";

import { usePricelist } from "@/pricelist/PricelistContext";
import { Price, PriceProps } from "@/products/components/Price";
import {
  getPriceOffer,
  Price as Offer,
  type PriceList,
} from "@/products/pricing";

export function PricelistPrice({
  originalItemPrice,
  subjectToVAT,
  pricelists,
  className,
  ...rest
}: {
  originalItemPrice: number | null | undefined;
  subjectToVAT: boolean | null | undefined;
  pricelists?: PriceList[] | null | undefined;
  className?: string;
} & Omit<PriceProps, keyof Offer>) {
  const { applicablePricelists } = usePricelist();
  const safePricelists = Array.isArray(pricelists) ? pricelists : [];

  const price = getPriceOffer({
    originalItemPrice,
    subjectToVAT,
    priceLists: safePricelists.filter((pricelist) =>
      applicablePricelists?.some(
        (applicable) => applicable.node?.identifier === pricelist.identifier,
      ),
    ),
  });

  return <Price {...price} className={className} {...rest} />;
}
